import { UserRole } from '@musicville/shared';
import type { PortalNavItem } from './portal-nav';

const ADMINS = [UserRole.ADMIN] as const;

export const ADMIN_NAV: readonly PortalNavItem[] = [
  { to: '/admin', labelKey: 'admin.nav.dashboard', icon: 'home', roles: ADMINS },
  { to: '/admin/bookings', labelKey: 'admin.nav.bookings', icon: 'calendar-check', roles: ADMINS },
  { to: '/admin/schedule', labelKey: 'admin.nav.schedule', icon: 'calendar', roles: ADMINS },
  { to: '/admin/teachers', labelKey: 'admin.nav.teachers', icon: 'user-check', roles: ADMINS },
  { to: '/admin/students', labelKey: 'admin.nav.students', icon: 'users', roles: ADMINS },
  { to: '/admin/rooms', labelKey: 'admin.nav.rooms', icon: 'door', roles: ADMINS },
  { to: '/admin/subjects', labelKey: 'admin.nav.subjects', icon: 'book-open', roles: ADMINS },
  { to: '/admin/payments', labelKey: 'admin.nav.payments', icon: 'wallet', roles: ADMINS },
  { to: '/admin/content', labelKey: 'admin.nav.content', icon: 'message-circle', roles: ADMINS },
  { to: '/admin/inbox', labelKey: 'admin.nav.inbox', icon: 'mail', roles: ADMINS },
  { to: '/admin/settings', labelKey: 'admin.nav.settings', icon: 'sliders', roles: ADMINS },
];

export function isAdminRole(role: UserRole | undefined): boolean {
  return role === UserRole.ADMIN;
}
